import "../models/provider.js";
import "./base.js";

// This will be used for the list of providers in the provider selector and in the ConfirmationModal
// It should allow a mix of model types, see https://backbonejs.org/#Collection-modelId which will be referenced by the Slot model.

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Collections ??= {};

AppointmentBooking.SlotSuggester.Collections.Providers = class Providers extends (
  AppointmentBooking.SlotSuggester.Collections.Base
) {
  comparator(provider) {
    return Math.random();
  }
}; // Don't favour specific providers until necessary
AppointmentBooking.SlotSuggester.Collections.Providers.prototype.model =
  AppointmentBooking.SlotSuggester.Models.Provider;
